import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { selectQuoteQuotationForm } from "../../../redux/selector";
import { useStyles } from "../styles";

const ReadOnlyField = ({
  labelKey,
  value,
  currency,
}: {
  labelKey: string;
  value: string;
  currency?: boolean;
}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const amount = !value || value === "0" ? "0" : value.replace(/[^\d.-]/g, "");

  return (
    <Box className={styles.fieldMetric}>
      <Typography className={styles.fieldMetricLabel}>{t(labelKey)}</Typography>
      <Typography className={styles.fieldMetricValue}>
        {currency ? (
          <span dir="ltr">{t("QUOTES.CURRENCY", { amount })}</span>
        ) : (
          value
        )}
      </Typography>
    </Box>
  );
};

const QuoteCosts = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const form = useSelector(selectQuoteQuotationForm);

  return (
    <Box className={styles.sectionsCard}>
      <Box className={styles.formSection}>
        <Box className={styles.sectionHeaderPlain}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.BASE_COSTS"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={formKey("FIELDS.WORK_HOURS")}
            value={form.workHours}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.PER_HOUR")}
            value={form.perHour}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.TOTAL_WORK_COST")}
            value={form.totalWorkCost}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.REPAIR_HOURS")}
            value={form.repairHours}
          />
        </Box>
      </Box>

      <Box className={styles.formSection}>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.PARAMETERS"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={formKey("FIELDS.SHEET_METAL_COST")}
            value={form.sheetMetalCost}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.CRANE_COMPLETION_ADDITION")}
            value={form.craneCompletionAddition}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.EXCHANGE_RATE")}
            value={form.exchangeRate}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.OTHER_SALE_ITEM")}
            value={form.otherSaleItem}
          />
        </Box>
      </Box>

      <Box className={styles.formSection}>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.PRICING"))}
          </Typography>
        </Box>
        <Box className={styles.grid3}>
          <ReadOnlyField
            labelKey={formKey("FIELDS.VARIABLE_COEFFICIENT")}
            value={form.variableCoefficient}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.DOWN_PAYMENT")}
            value={form.downPayment}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.VEHICLE_WEIGHT_WITHOUT_SIDE")}
            value={form.vehicleWeightWithoutSide}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default QuoteCosts;
